import React, { useEffect } from 'react';
import { Prompt } from 'react-router-dom';
import { useHasUnsavedChanges } from '../../../hooks/useEligibilityEngine';

const UNSAVED_CHANGES_MESSAGE = 'You have unsaved changes. Are you sure you want to leave?';

const UnsavedChangesGuard = () => {
  const hasUnsavedChanges = useHasUnsavedChanges();

  // Warn on browser close / refresh when there are unsaved changes.
  useEffect(() => {
    if (!hasUnsavedChanges) return undefined;
    const handleBeforeUnload = e => {
      e.preventDefault();
      // Modern browsers require returnValue to be set to trigger the dialog.
      e.returnValue = UNSAVED_CHANGES_MESSAGE;
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [hasUnsavedChanges]);

  // Block React Router internal navigation when there are unsaved changes.
  return <Prompt when={hasUnsavedChanges} message={UNSAVED_CHANGES_MESSAGE} />;
};

export default UnsavedChangesGuard;
